jQuery(function($)
{
    if($(window).width() > 1) 
    {
        //$("div#shopify-section-template--23646151147830__testimonials_d4N4LY .m-testimonials--layout-1 .m-testimonial__image").remove().insertBefore($("div#shopify-section-template--23646151147830__testimonials_d4N4LY .m-testimonials--layout-1 .m-stars"));
        //$(".product-popup-sec1").remove().insertBefore($("label#po_label458874"));
       //$("div#shopify-section-template--23646151147830__testimonials_d4N4LY .m-testimonials--layout-1 .m-testimonial__image").remove().insertBefore($("div#shopify-section-template--23646151147830__testimonials_d4N4LY .m-testimonials--layout-1 .m-stars"));
       $("p.christmas-pickup-option1.option1").remove().insertAfter($("div#shopify-section-template--25568486424886__new_featured_product_3t4rDk .product-block-group--price"));
       $("p.christmas-pickup-option1.option2").remove().insertAfter($("div#shopify-section-template--25568486424886__new_featured_product_R9ck7M .product-block-group--price"));
       $("p.christmas-pickup-option1.option3").remove().insertAfter($("div#shopify-section-template--25568486424886__new_featured_product_cMj7mX .product-block-group--price"));
    }

    if($(window).width() < 760) 
    {
        $("div#m-custom__block--liquid_NJMtbt").remove().insertAfter($("div#m-custom__block--image_eJpX6i"));
        $("span.m-footer__copyright.logo_bottms1").remove().insertAfter($(".footer-second-sect1 .foter-social.affilate"));
        $(".cooking-time-inner-column2 video.videoplace1.gnocchi").remove().insertAfter($(".box-inner-cooking-time-sec1 h2.hminutes-titl.gnocchi"));
        $(".cooking-time-inner-column2 video.videoplace1.fieldpasta").remove().insertAfter($(".box-inner-cooking-time-sec1 h2.hminutes-titl.fieldpasta"));
        $(".cooking-time-inner-column2 video.videoplace1.butter-sauc").remove().insertAfter($(".box-inner-cooking-time-sec1 h2.hminutes-titl.butter-sauc"));
        $(".cooking-time-inner-column2 video.videoplace1.other-pasta").remove().insertAfter($(".box-inner-cooking-time-sec1 h2.hminutes-titl.other-pasta"));
    }
}); 


$(document).ready(function(){
    $("p.allergens-para1.newtemp strong:nth-child(2)").addClass("pipes1");

});


$(document).ready(function() {
  var rightNow = new Date();
  var day = rightNow.getUTCDay();
  var hour = rightNow.getHours();
  var minutes = rightNow.getMinutes();

  if (day >= 0 && day <= 6 && hour >= 6 && hour <= 11 && minutes >= 0 && minutes <= 59) {
    $("#morning-time-based").show();
  } else {
    $("#morning-time-based").hide();
  }
  
  if (day >= 0 && day <= 6 && hour >= 12 && hour <= 13 && minutes >= 0 && minutes <= 59) {
    $("#afternoon-time-based").show();
  } else {
    $("#afternoon-time-based").hide();
  }
  
   if (day >= 0 && day <= 6 && hour >= 14 && hour <= 18 && minutes >= 0 && minutes <= 59) {
    $("#evening-time-based").show();
  } else {
    $("#evening-time-based").hide();
  }
  
  if (day >= 0 && day <= 6 && hour >= 19 && hour <= 23 && minutes >= 0 && minutes <= 59) {
    $("#night-time-based").show();
  } else {
    $("#night-time-based").hide();
  }
  
});
